import { MsalProvider } from '@azure/msal-react'
import type { ReactNode } from 'react'
import { isAzureAuthEnabled } from './authMode'
import { msalInstance } from './msalInstance'

export default function AuthProvider({ children }: { children: ReactNode }) {
  if (!isAzureAuthEnabled || !msalInstance) {
    return <>{children}</>
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
}
